const EducationList = [
  {
    collegeName: "Faculty of Engineering - University of Sri Jayewardenepura, Sri Lanka",
    courseName: "B. Sc. Eng (Hons) in Computer Engineering - Minor Specialization : Data Management",
    couseStartYear: "Nov 2019",
    courseEndYear: "June 2024",
    details: [
        "Current GPA - 3.84", 
        "Dean List - semester 1, 2, 3, 5 and 8"
    ],
  },
  {
    collegeName: "University of Colombo School of Computing, Sri Lanka",
    courseName: "Training Course on JAVA",
    couseStartYear: "Jan 2019",
    courseEndYear: "March 2019",
    details: [
        "Database, Java, Object-Oriented Programming(OOP)"
    ],
  },
  {
    collegeName: "ESOFT Metro Campus, Sri Lanka",
    courseName: "Diploma in Software Engineering",
    couseStartYear: "Dec 2015",
    courseEndYear: "Aug 2016",
    details: [
        "SQL, VB, C#"
    ],
  },
  {
    collegeName: "Nalanda National College - Minuwangoda, Sri Lanka",
    courseName: "Primary Education",
    couseStartYear: "Jan 2004",
    courseEndYear: "Dec 2008",
    details: [
        "Grade 5 Scholarship Examination - 177 Marks "
    ],
  },
  {
    collegeName: "Bandaranayake College - Gampaha, Sri Lanka",
    courseName: "Physical Science Stream",
    couseStartYear: "Jan 2009",
    courseEndYear: "Aug 2018",
    details: [
        "GCE Ordinary Level Examination (2015) : 8A & 1C", 
        "GCE Ordinary Level Examination (2016) : 1C - Tamil",
        "GCE Advance Level Examination (2018) : 3A's - Physics, Chemistry, General English & 1B - Combined Mathematics",
	    "Z - Score - 1.7432		Island rank - 1293	       District Rank - 116 (Gampaha)"
    ],
  }
];
const EducationData = {EducationList};
export default EducationData;
